<template>
  <div class="portal_program_content">
    <div class="container">
      <div class="row justify-content-lg-between">
        <div class="col-md-12 g-pt-50 g-pt-100--md g-pb-70">
          <div class="row">
            <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 pp_image g-px-0">
              <div
                style="
                  position: relative;
                  width: 100%;
                  height: 0;
                  padding-bottom: 56.25%;
                "
              >
                <iframe
                  loading="lazy"
                  src="https://www.youtube-nocookie.com/embed/j03iJHt8q2A?si=RLQgQUuQpspJ0B-n&showinfo=0&rel=0&modestbranding=1&autoplay=1&mute=1"
                  frameborder="0"
                  allowfullscreen
                  style="
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                  "
                ></iframe>
              </div>
            </div>
            <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 second">
              <div class="portal_info ml-md-4">
                <div class="pp_benefit_content">
                  <p class="pp_title">User Testimonial</p>
                  <div class="program_desc_container">
                    <p class="pp_description">Hear from Dr. Kristin Reed about how the Champions for Sight® program has helped her make an impact in her community and her practice. </p>
                    <p class="pp_description">By participating in the program, you and your team can make a tangible difference in the lives of others!</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    RouterRedirect(name) {
      var href = window.location.href;
      if (href[href.length - 1] == "/")
        window.open("../" + name + "/", "_blank");
      else window.open(href + "/../" + name + "/", "_blank");
    },
  },
};
</script>



// WEBPACK FOOTER //
// HomePromo.vue?62038b56